import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Hamburger } from './Hamburger';

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transparent: props.isTransparentWhenAtScrollTop,
    };
  }

  componentDidMount() {
    if (this.props.isTransparentWhenAtScrollTop) {
      this.installScrollHandler();
    }
  }

  componentDidUpdate() {
    const { isTransparentWhenAtScrollTop } = this.props;

    if (isTransparentWhenAtScrollTop) {
      this.installScrollHandler();
    } else {
      this.uninstallScrollHandler();
    }
  }

  componentWillUnmount() {
    this.uninstallScrollHandler();
  }

  handleScroll = (event, scrollAmount = 0) => {
    const { transparent } = this.state;
    const atTop = (scrollAmount || window.pageYOffset || document.documentElement.scrollTop) <= 5;

    if (transparent !== atTop) {
      this.setState({ transparent: atTop });
    }
  };

  installScrollHandler() {
    if (!this.scrollHandler) {
      this.scrollHandler = this.handleScroll;
      if (__CLIENT__) {
        window.addEventListener('scroll', this.scrollHandler, true);
      }
      this.handleScroll();
    }
  }

  uninstallScrollHandler() {
    if (this.state.transparent) {
      this.setState({ transparent: false });
    }
    if (this.scrollHandler) {
      if (__CLIENT__) {
        window.removeEventListener('scroll', this.scrollHandler, true);
      }
      this.scrollHandler = null;
    }
  }

  render() {
    const {
      children,
      isDark,
      isMobile,
      showHamburger,
      dropdownOpen,
      onDropdownStateToggled,
      isTransparentWhenAtScrollTop,
    } = this.props;

    const { transparent } = this.state;

    const dropdownOpenOnMobile = dropdownOpen && isMobile;

    return (
      <header
        className={classNames('header', {
          'header--can-be-transparent': isTransparentWhenAtScrollTop && !dropdownOpenOnMobile,
          'header--transparent': transparent && !dropdownOpenOnMobile,
          'header--dark': isDark,
        })}>
        <div className="alpha header__logo">
          <a href="/">ClassPass</a>
        </div>

        {children}

        {showHamburger && <Hamburger open={dropdownOpen} onClick={onDropdownStateToggled} className="lg-hidden" />}
      </header>
    );
  }
}

Header.propTypes = {
  onDropdownStateToggled: PropTypes.func,
  isDark: PropTypes.bool,
  isTransparentWhenAtScrollTop: PropTypes.bool,
  showHamburger: PropTypes.bool,
  isMobile: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
  children: PropTypes.node,
};
